import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Approval } from '@interfaces';

@Component({
    selector: 'tab-approvals-equipments-custom-fields',
    templateUrl: './tab-approvals-equipments-custom-fields.component.html'
})
export class TabApprovalsEquipmentsCustomFieldsComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public approval: Approval
    ) {}
}
